module.exports = __webpack_public_path__ + "img/goal-sixteen-br.351ca4a3.png";